import React from "react";
import { FieldErrors, FieldValues, useFormContext } from "react-hook-form";
import { PaziaErrorMessage } from "../PaziaErrorMessage/PaziaErrorMessage";

const resolveErrorMessage = (
  errors: FieldErrors<FieldValues>,
  name: string
) => {
  switch (errors[name]?.type) {
    case "optionality":
    case "required":
    case "nullable":
      return "To pole jest wymagane.";
    case "email":
      return "Niepoprawny adres email.";
    case "url":
      return "Niepoprawny adres URL.";
    case "typeError":
      return "Niepoprawny format.";
    case "min":
      return "Wartość jest za mała.";
    default:
      return !errors[name]?.type ? "" : errors[name]?.message?.toString();
  }
};

export interface InputErrorMessageProps {
  name: string;
}

export const InputErrorMessage = ({
  name,
}: InputErrorMessageProps): JSX.Element | null => {
  const {
    formState: { errors },
  } = useFormContext();
  const errorMessage = resolveErrorMessage(errors, name);

  if (!errorMessage) return null;
  return <PaziaErrorMessage>{errorMessage}</PaziaErrorMessage>;
};
